import { render } from "./publish-modal.vue?vue&type=template&id=3db81df4"
import script from "./publish-modal.vue?vue&type=script&lang=js"
export * from "./publish-modal.vue?vue&type=script&lang=js"
script.render = render

export default script